import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector } from "@mui/x-data-grid";

import { UserRole } from "../../services/api/AuthUser";
import RoleBasedRender from "../shared/RoleBasedRender";
import JobsMultiFilterButton from "./JobMultiFilterButton";
import JobsExportButton from "./JobsExportButton";
import JobRetranscodeButton from "./JobsRetranscodeButton";

const JobsTableBar: React.FC<{ ids?: string[]; backfill?: boolean }> = (props) => {
  const navigate = useNavigate();

  if (props.backfill) {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <div style={{ flexGrow: 1 }}></div>
        <Button size="small" variant="contained" onClick={() => navigate("/backfill/create")}>
          Create Backfill
        </Button>
      </GridToolbarContainer>
    );
  } else {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <JobsMultiFilterButton />
        <GridToolbarDensitySelector />
        <JobsExportButton />
        <div style={{ flexGrow: 1 }}></div>
        <RoleBasedRender requiredRoles={[UserRole.ADMIN, UserRole.OPERATOR]}>
          <JobRetranscodeButton ids={props.ids!} />
          <Button size="small" variant="contained" onClick={() => navigate("/jobs/create")}>
            Create Job
          </Button>
        </RoleBasedRender>
      </GridToolbarContainer>
    );
  }
};

export default JobsTableBar;
